import React from 'react';

import classNames from 'classnames';

import ChestIcon from '@uikit/icons/Chest';
import FireIcon from '@uikit/icons/Fire';
import LevelHighIcon from '@uikit/icons/LevelHigh';
import ReloadIcon from '@uikit/icons/Reload';
import StarIcon from '@uikit/icons/Star';
import TimeIcon from '@uikit/icons/Time';

import {
  REWARD_POOL_DISTRIBUTION_POLICY,
  REWARD_POOL_TAG,
  RewardPool,
} from '@shared/api/types/rewardPools';

interface Props {
  rewardPool: RewardPool;
  className?: string;
}

const getRewardPoolTags = (rewardPool: RewardPool) => {
  return [
    {
      id: 'featured',
      label: 'Featured',
      className: 'badge-blue-reverse',
      Icon: StarIcon,
      show: rewardPool.tags?.includes(REWARD_POOL_TAG.FEATURED),
    },
    {
      id: 'trending',
      label: 'Trending',
      className: 'badge-green-reverse',
      Icon: LevelHighIcon,
      show: rewardPool.tags?.includes(REWARD_POOL_TAG.TRENDING),
    },
    {
      id: 'hot',
      label: 'Hot',
      className: 'badge-red-reverse',
      Icon: FireIcon,
      show: rewardPool.tags?.includes(REWARD_POOL_TAG.HOT),
    },
    {
      id: 'huge-reward',
      label: 'Huge Reward',
      className: 'badge-orange-reverse',
      Icon: ChestIcon,
      show: rewardPool.tags?.includes(REWARD_POOL_TAG.HUGE_REWARD),
    },
    {
      id: 'last-chance',
      label: 'Last Chance',
      className: 'badge-purple-reverse',
      Icon: TimeIcon,
      show: rewardPool.tags?.includes(REWARD_POOL_TAG.LAST_CHANCE),
    },
    {
      id: 'daily',
      label: 'Daily',
      className: 'badge-pink',
      Icon: ReloadIcon,
      show: rewardPool.recreation,
    },
    {
      id: 'type',
      label: {
        [REWARD_POOL_DISTRIBUTION_POLICY.FCFS]: 'FCFS',
        [REWARD_POOL_DISTRIBUTION_POLICY.FCFS_V2]: 'FCFS',
        [REWARD_POOL_DISTRIBUTION_POLICY.PRO_RATA_KARMA]: 'Pro-Rata',
        [REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE]: 'Raffle',
        [REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_V2]: 'Raffle',
      }[rewardPool.distribution_policy],
      show: true,
    },
  ].filter((tag) => tag.show);
};

export const RewardPoolCardTags = ({ rewardPool, className }: Props) => {
  const tags = getRewardPoolTags(rewardPool);

  return (
    <ul
      className={classNames('flex flex-wrap gap-1 xl:gap-[0.375rem]', className)}
      data-qa="tags_list"
    >
      {tags.map(({ id, label, Icon, className: tagClassName }) => {
        return (
          <li
            key={id}
            className={classNames('badge badge-sm xl:badge-md', tagClassName)}
            data-qa={label}
          >
            {Icon && <Icon className="badge-icon" />}
            {label}
          </li>
        );
      })}
    </ul>
  );
};
